// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1sKwj","footer":"ReportModalFilter_footer__1L5ZB"};